// Provide your desired order of attributes listed in product hits here, in descending order
// These attributes/facets will also needs to be configured in the Algolia index, under "Retrieved attributes"

export interface ProductHitPreviewAttributesWithTranslations {
	/**
	 * Name of the attribute in Algolia
	 */
	name: string
	label: {
		/**
		 * Translation by language
		 */
		[lang: string]: string
		de: string
	}
}

const productHitPreviewAttributes: ProductHitPreviewAttributesWithTranslations[] = [
	{
		name: "Sicherheitslevel",
		label: {
			de: "Sicherheitslevel",
		},
	},
	{
		name: "Systemtyp",
		label: {
			de: "Systemtyp",
		},
	},
	{
		name: "Patentlaufzeit",
		label: {
			de: "Patentlaufzeit",
		},
	},
	{
		name: "Wendeschlüssel",
		label: {
			de: "Wendeschlüssel",
		},
	},
	{
		name: "System",
		label: {
			de: "System",
		},
	},
	{
		name: "numberOfKeyHooks",
		label: {
			de: "Anzahl Schlüsselhaken",
		},
	},
	{
		name: "weightKg",
		label: {
			de: "Gewicht (kg)",
		},
	},
	{
		name: "color",
		label: {
			de: "Farbe",
		},
	},
	{
		name: "volumeLiter",
		label: {
			de: "Volumen (l)",
		},
	},
	{
		name: "manufacturer",
		label: {
			de: "Hersteller",
		},
	},
]

// A maximum of n attributes will be shown
export const maxProductHitPreviewAttributes = 3

export default productHitPreviewAttributes
